<template>
  <div class="page-container">
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        :size="size"
      >
        <el-form-item label="志愿者姓名">
          <el-input
            v-model.trim="filters.userName"
            placeholder="请输入志愿者姓名"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="志愿者电话">
          <el-input
            v-model="filters.mobileNo"
            placeholder="请输入志愿者电话"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="filters.sex" clearable placeholder="请选择性别">
            <el-option
              v-for="item in sexOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            label="查询"
            type="primary"
            @click="findPage(null)"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-plus"
            label="新增"
            type="warning"
            @click="handleAdd"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-refresh"
            label="刷新"
            type="primary"
            @click="handleRefresh"
          />
        </el-form-item>
      </el-form>
    </el-scrollbar>
    <!--表格内容栏-->
    <kt-table
      v-loading="loading"
      :height="'400'"
      element-loading-text="拼命加载中"
      :data="pageResult"
      :columns="filterColumns"
      :operationWidth="100"
      :showEdit="false"
      :showDelete="false"
      :showLook="true"
      @findPage="findPage"
      @handleLook="handleLook"
      @refreshPageRequest="refreshPageRequest"
    >
    </kt-table>
    <!-- 新增礼品兑换和修改礼品兑换的dialog模态框-->
    <el-dialog
      class="volunteerdialog"
      :title="operation ? '新增礼品兑换' : '修改礼品兑换'"
      width="30%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogReset"
    >
      <el-form
        :model="dataForm"
        label-width="120px"
        :rules="dataFormRules"
        ref="dataForm"
        :size="size"
        label-position="right"
      >
        <el-form-item label="志愿者姓名:" prop="volunteerId">
          <el-select
            v-model="dataForm.volunteerId"
            filterable
            placeholder="请选择志愿者"
            style="width: 80%"
            @change="changeOldman"
          >
            <el-option
              v-for="item in volunteerOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="礼品名称:" prop="giftId">
          <el-select
            v-model="dataForm.giftId"
            filterable
            placeholder="请选择礼品"
            style="width: 80%"
            @change="changeGift"
          >
            <el-option
              v-for="item in giftOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换类型:" prop="convertType">
          <el-select
            v-model.trim="dataForm.convertType"
            placeholder="请选择兑换类型"
            style="width: 80%"
            @change="changeConvertType"
          >
            <el-option
              v-for="item in convertTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流公司名称:" prop="lgsCompany" v-if="showInfo">
          <el-input
            v-model.trim="dataForm.lgsCompany"
            auto-complete="off"
            placeholder="请输入物流公司名称"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="物流单号:" prop="lgsNumber" v-if="showInfo">
          <el-input
            v-model.trim="dataForm.lgsNumber"
            auto-complete="off"
            placeholder="请输入物流单号"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="收货地址:" prop="address" v-if="showInfo">
          <el-input
            v-model.trim="dataForm.address"
            auto-complete="off"
            placeholder="请输入收货地址"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="说明:" prop="remark">
          <el-input
            v-model.trim="dataForm.remark"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder="请输入说明"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitForm"
          :loading="editLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
  components: {
    KtTable,
    KtButton,
  },
  data() {
    return {
      loading: true,
      size: "medium",
      filters: {
        userName: "",
        mobileNo: "",
        sex: "",
      },
      sexOptions: [], //工具栏中性别
      volunteerOptions: [], //dialog模态框中的志愿者
      giftOptions: [], //dialog模态框中的礼品
      convertTypeOptions: [], //dialog模态框中的兑换类型
      columns: [],
      filterColumns: [],
      pageRequest: { pageNum: 1, pageSize: 10 },
      pageResult: {},
      dataForm: {},
      operation: false, // true:新增, false:编辑
      dialogVisible: false, // 新增编辑界面是否显示
      editLoading: false, //修改loading
      dataFormRules: {
        volunteerId: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        giftId: [{ required: true, message: "不能为空", trigger: "change" }],
        convertType: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        lgsCompany: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        lgsNumber: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1到 20 个字符" },
          { pattern: /^[0-9]+$/, message: "请输入由数字组成的字符" },
        ],
        address: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
        ],
        remark: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1到 50 个字符" },
        ],
      },
      pageinfo: { pageNum: 0, pageSize: 0 },
      showInfo: true,
    };
  },
  methods: {
    // 刷新
    handleRefresh() {
      this.filters = {}; //清空查询条件
      this.findPage();
    },
    // 关闭dialog清除验证
    closeDialogReset() {
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
      });
      this.showInfo = true;
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.findPage();
      }
    },
    // 获取分页数据
    findPage(data) {
      //判断查询条件是否存在
      this.filters.userName != undefined
        ? (this.pageRequest.userName = this.filters.userName)
        : (this.pageRequest.userName = "");
      this.filters.mobileNo != undefined
        ? (this.pageRequest.mobileNo = this.filters.mobileNo)
        : (this.pageRequest.mobileNo = "");
      this.filters.sex != undefined
        ? (this.pageRequest.sex = this.filters.sex)
        : (this.pageRequest.sex = "");
      console.log(this.pageRequest);
      this.$postJson("omc/convert/queryListWithPage", this.pageRequest)
        .then((res) => {
          console.log(res.result, "==============前");
          res.result.list.forEach((item) => {
            console.log(item.sex + "-----------");
            item.sex == 0 ? (item.sex = "女") : (item.sex = "男");
            item.convertType = item.convertType.replace(/\s*/g, "");
            item.convertType == "online"
              ? (item.convertType = "线上")
              : (item.convertType = "线下");
            item.stat == 0
              ? (item.stat = "已完成")
              : item.stat == 1
              ? (item.stat = "待发货")
              : (item.stat = "已发货");
            item.address == ""
              ? (item.address = "----------")
              : (item.address = item.address);
            item.lgsCompany == ""
              ? (item.lgsCompany = "----------")
              : (item.lgsCompany = item.lgsCompany);
            item.lgsNumber == ""
              ? (item.lgsNumber = "----------")
              : (item.lgsNumber = item.lgsNumber);
          });
          console.log(res.result, "---------后");
          this.pageResult = res.result;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .then(data != null ? data.callback : "");
    },
    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },
    // 删除
    handleDelete(data) {
      console.log(data.params[0].id, data.callback);
      let volunteerId = data.params[0].id;
      console.log(volunteerId);
      this.$postForm("uac/volunteer/deleteById/" + volunteerId).then((res) => {
        console.log(res);
        var info = res;
        data.callback(info);
      });
    },
    // 显示新增界面
    handleAdd() {
      this.dialogVisible = true;
      this.operation = true;
      this.dataForm = {
        volunteerId: "",
        giftId: "",
        convertType: "",
        lgsCompany: "",
        lgsNumber: "",
        address: "",
        remark: "",
      };
    },
    // 显示编辑界面
    handleEdit(params) {
      this.dialogVisible = true;
      this.operation = false;
      this.dataForm = Object.assign({}, params.row);
    },
    // 新增和编辑提交数据
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let params = Object.assign({}, this.dataForm);
          console.log(this.operation, params);
          //this.operation==true为新增的url  this.operation==false为修改的url
          let url = "";
          this.operation == true
            ? (url = "omc/convert/add")
            : (url = "uac/volunteer/edit");
          console.log(url);
          this.$postJson(url, params).then((res) => {
            console.log(res);
            this.editLoading = false;
            if (res.code == 200) {
              this.$message({ message: "操作成功", type: "success" });
              this.dialogVisible = false;
              this.$refs["dataForm"].resetFields();
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
            }
            this.findPage();
          });
        }
      });
    },
    //查看详情
    handleLook(data) {
      console.log(data);
      let id = data.row.id;
      console.log(id);
      this.$router.push({
        path: "/volunteergiftsRecordDetail",
        query: { id: id },
      }); //编程式导航跳转  query传参
    },
    //选择老人
    changeOldman(val) {
      console.log(val);
    },
    //选取礼品
    changeGift(val) {
      console.log(val);
    },
    //dialog中选取兑换类型
    changeConvertType(val) {
      console.log(val);
      val == "offline" ? (this.showInfo = false) : (this.showInfo = true);
      console.log(this.showInfo);
      this.dataForm.lgsCompany = "";
      this.dataForm.lgsNumber = "";
      this.dataForm.address = "";
      this.dataForm.remark = "";
    },
    //获取所有志愿者的volunteerId和userName
    getVolunteerInfo() {
      this.$postJson("uac/volunteer/queryListWithPage", this.pageinfo).then(
        (res) => {
          console.log(res.result);
          res.result.list.forEach((item) => {
            console.log(item);
            var volunteerObj = {};
            volunteerObj.label = item.userName;
            volunteerObj.value = item.id;
            this.volunteerOptions.push(volunteerObj);
            console.log(this.volunteerOptions);
          });
        }
      );
    },
    //获取所有礼品的giftId和giftName
    getGiftInfo() {
      this.$postJson("omc/gift/queryListWithPage", this.pageinfo).then(
        (res) => {
          console.log(res.result);
          res.result.list.forEach((item) => {
            console.log(item);
            if (item.stock > 0) {
              //判断库存大于0才添加
              var giftObj = {};
              giftObj.label = item.giftName;
              giftObj.value = item.id;
              this.giftOptions.push(giftObj);
              console.log(this.giftOptions);
            }
          });
        }
      );
    },
    // 处理表格列过滤显示
    displayFilterColumnsDialog() {
      this.$refs.tableColumnFilterDialog.setDialogVisible(true);
    },
    // 处理表格列过滤显示
    handleFilterColumns(data) {
      this.filterColumns = data.filterColumns;
      this.$refs.tableColumnFilterDialog.setDialogVisible(false);
    },
    // 处理表格列过滤显示
    initColumns() {
      this.columns = [
        { prop: "userName", label: "志愿者姓名", minWidth: 120 },
        { prop: "sex", label: "性别", minWidth: 120 },
        { prop: "giftName", label: "礼品名称", minWidth: 120 },
        { prop: "convertType", label: "兑换类型", minWidth: 120 },
        { prop: "lgsCompany", label: "物流公司名称", minWidth: 130 },
        { prop: "lgsNumber", label: "物流单号", minWidth: 120 },
        { prop: "address", label: "收货地址", minWidth: 120 },
        { prop: "remark", label: "说明", minWidth: 120 },
        { prop: "stat", label: "发货状态", minWidth: 120 },
      ];
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));
    },
    //初始化是否发货和是否上架
    initialSexs() {
      var sexs = ["女", "男"];
      for (var i = 0; i < sexs.length; i++) {
        var item = {};
        item.value = i;
        item.label = sexs[i];
        this.sexOptions.push(item);
      }
    },
    //初始化dialog模态框中的兑换类型
    initialConvertTypes() {
      var convertTypes = ["线下", "线上"];
      for (var i = 0; i < convertTypes.length; i++) {
        var item = {};
        item.label = convertTypes[i];
        item.label == "线下"
          ? (item.value = "offline")
          : (item.value = "online");
        this.convertTypeOptions.push(item);
        console.log(this.convertTypeOptions);
      }
    },
  },
  created() {
    this.initialSexs();
    this.initialConvertTypes();
  },
  mounted() {
    this.initColumns();
    this.findPage();
    this.getVolunteerInfo();
    this.getGiftInfo();
  },
};
</script>

<style lang="scss" scoped>
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增 编辑 dialog
@media screen and (max-width: 1599px) {
  ::deep .volunteerdialog .el-dialog {
    width: 60% !important;
  }
}
::deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  width: 100.5%;
  height: 100%;
}
::deep .el-form--inline {
  position: relative;
  z-index: 99;
}
.filtersposition {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 10px;
  width: 100%;
  height: 56px;
  background: #f2f2f2;
  z-index: 1;
}
</style>